<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar campo adicional' : 'Novo campo adicional' }}</h1>
                        <p class="welcome-message">
                            <button mat-icon-button type="button" (click)="voltar()"><mat-icon>arrow_back</mat-icon></button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} o campo adicional da
                            ordem de serviço.
                        </p>
                    </div>
                </div>
            </div>
            @if(isLoading) {
            <div class="col-12"><app-loading-box height="200"></app-loading-box></div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">
                    <div class="section-container">
                        <div class="section-title">
                            <mat-icon class="material-symbols-outlined">playlist_add</mat-icon>
                            <span>Dados do campo</span>
                        </div>

                        <div class="conteudo-secao">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Nome do campo</mat-label>
                                <input matInput formControlName="nome" [maxlength]="tamanhoMaximoNome" required>
                                <mat-hint align="end">{{ form.get('nome')?.value?.length || 0 }} / {{ tamanhoMaximoNome }}</mat-hint>
                                @if (form.get('nome')?.hasError('required')) {
                                <mat-error>O nome do campo é <strong>obrigatório</strong>.</mat-error>
                                }
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Tipo</mat-label>
                                <mat-select formControlName="idTipoCampoAdicional" required>
                                    @for (tipo of listaTipoCampoAdicional; track tipo.idTipoCampoAdicional) {
                                    <mat-option [value]="tipo.idTipoCampoAdicional">{{ tipo.descricao }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>

                            @if (isListaOpcoes) {
                            <div class="mb-3">
                                <div class="subsection-title mb-0">Opções da lista</div>
                                <p class="sub-section-sub-title">Informe ao menos duas opções, sem repetição. Arraste
                                    para reordenar.</p>

                                <div class="d-grid gap-2 mb-3" formArrayName="listaOpcoes" cdkDropList
                                    (cdkDropListDropped)="reordenarOpcoes($event)">
                                    @for (opcao of opcoes.controls; track opcao; let i = $index) {
                                    <div class="d-flex align-items-center gap-2" [formGroupName]="i" cdkDrag
                                        (cdkDragStarted)="isArrastandoOpcao = true" (cdkDragEnded)="isArrastandoOpcao = false">
                                        <mat-icon class="material-symbols-outlined drag-handle" cdkDragHandle
                                            matTooltip="Arraste para reordenar."
                                            [matTooltipDisabled]="isArrastandoOpcao">drag_indicator</mat-icon>
                                        <ng-template cdkDragPreview [matchSize]="true">
                                            <div class="opcao-preview item-preview">
                                                <mat-icon class="material-symbols-outlined drag-handle">drag_indicator</mat-icon>
                                                <span>{{ opcao.get('descricao')?.value || 'Opção ' + (i + 1) }}</span>
                                            </div>
                                        </ng-template>
                                        <mat-form-field appearance="outline" subscriptSizing="dynamic" class="flex-grow-1">
                                            <input matInput formControlName="descricao" [placeholder]="'Opção ' + (i + 1)"
                                                [maxlength]="tamanhoMaximoOpcao">
                                        </mat-form-field>
                                        <button mat-icon-button type="button" matTooltip="Remover opção."
                                            (click)="removerOpcao(i)">
                                            <mat-icon class="material-symbols-outlined">close</mat-icon>
                                        </button>
                                    </div>
                                    }
                                </div>

                                <button mat-stroked-button type="button" class="btn-secondary"
                                    (click)="adicionarOpcao()">
                                    <mat-icon class="material-symbols-outlined">add</mat-icon>
                                    Adicionar opção
                                </button>
                            </div>
                            }
                        </div>

                        <div class="section-title mt-4">
                            <mat-icon class="material-symbols-outlined">rule</mat-icon>
                            <span>Preenchimento</span>
                        </div>

                        <div class="conteudo-secao">
                            <div class="toggle-content">
                                <mat-slide-toggle class="app-toggle-compact" color="primary"
                                    formControlName="isObrigatorioCriacao">
                                    Obrigatório na criação da ordem de serviço
                                </mat-slide-toggle>
                                <span class="info-text">A ordem só pode ser salva pela primeira vez com este campo
                                    preenchido. Nas edições seguintes o preenchimento é livre.</span>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            }
        </div>
    </div>
</div>
<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>
